import Vue from 'vue'
const vm = new Vue()

// const url_prefix = "/wisdom-portal";
const url_prefix = "";


function getUrl(url) {
  return vm.$http.adornUrl(url_prefix + url);
}

/**
 * 微卡登录
 * @param params
 * @returns {*}
 */
export const wkLogin = params => {
  return vm.$http.get(getUrl(`/login/loginWithWKCode`), {params: params}).then((res) => res.data)
}



// WEBPACK FOOTER //
// ./src/api/wkApi.js